import React from 'react'
import CourseItem from '../../shared/course-item'

import Slider from "react-slick";
import CourseFeedbackItem from '../../shared/courseFeedbackItem';


export default function courseFeedbacks(props) {

    var settings = {
        dots: false,
        infinite: false,
        speed: 200,
        arrows: false,
        slidesToShow: 2.5,
        slidesToScroll: 2.5,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows:false
                }
            }
        ]
    };

    return (
        <div className='container-margin-bottom'>
            <div className="sectionTitle">
                {props.title}
            </div>
            <div className="titleUnderline">
                <div className="thickLine course-feedback-underline"></div>
                <div className="thinLine"></div>
            </div>
            <div className="course-container">
                <Slider {...settings}>
                    {
                        props.data.map((item, index) => {
                            return <CourseFeedbackItem key={index} data={item} btntitle={props.btntitle} />
                        })
                    }
                </Slider>
            </div>
            {props.data && <div className='comment-txt'>{props.data.length} comments</div>}
        </div>
    )
}
